import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import api from '../../api/api';

export default function ClientDashboard() {
  const { currentUser, logout } = useAuth();
  const { activeWorkspace, loading: wsLoading } = useWorkspace();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activeWorkspace) return;
    const fetchStats = async () => {
      try {
        const clientId = currentUser?.clientId?._id || currentUser?.clientId;
        if (!clientId) return;
        const res = await api.get('/clients/' + clientId + '/stats', {
          headers: { 'x-workspace-id': activeWorkspace._id },
        });
        setStats(res.data);
      } catch (err) {
        console.error('Erreur stats client:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [activeWorkspace, currentUser]);

  if (wsLoading) {
    return React.createElement('div', { className: 'flex items-center justify-center h-screen' }, 'Chargement...');
  }

  if (!activeWorkspace) {
    return React.createElement('div', { className: 'flex items-center justify-center h-screen' },
      React.createElement('p', null, 'Aucun espace disponible. Contactez votre cabinet.')
    );
  }

  const menuItems = [
    { label: 'Factures Ventes', icon: '🧾', path: '/client/invoices' },
    { label: 'Paiements', icon: '💳', path: '/client/payments' },
    { label: 'Achats', icon: '🛒', path: '/client/purchase-invoices' },
    { label: 'Tresorerie', icon: '🏦', path: '/client/treasury' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-indigo-700 text-white px-6 py-4 flex items-center justify-between shadow">
        <div>
          <h1 className="text-xl font-bold">AccountInTime</h1>
          <p className="text-indigo-200 text-sm">{activeWorkspace.name}</p>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-sm text-indigo-200">{currentUser?.name}</span>
          <button onClick={logout} className="text-sm bg-indigo-600 hover:bg-indigo-500 px-3 py-1 rounded">
            Deconnexion
          </button>
        </div>
      </div>
      <div className="max-w-5xl mx-auto p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Tableau de bord</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-white rounded-xl shadow p-5 border-l-4 border-indigo-500">
            <p className="text-sm text-gray-500">Total Factures</p>
            <p className="text-3xl font-bold text-gray-800 mt-1">{loading ? '...' : (stats?.totalFactures ?? 0)}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-5 border-l-4 border-green-500">
            <p className="text-sm text-gray-500">Montant Total</p>
            <p className="text-3xl font-bold text-gray-800 mt-1">{loading ? '...' : ((stats?.totalMontant ?? 0).toFixed(3) + ' TND')}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-5 border-l-4 border-purple-500">
            <p className="text-sm text-gray-500">Espace de travail</p>
            <p className="text-lg font-bold text-gray-800 mt-1 truncate">{activeWorkspace.name}</p>
          </div>
        </div>
        <h3 className="text-lg font-semibold text-gray-700 mb-4">Acces rapide</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {menuItems.map((item) => (
            <a key={item.path} href={item.path} className="bg-white rounded-xl shadow p-5 flex flex-col items-center gap-2 hover:shadow-md border border-transparent hover:border-indigo-300 transition text-center">
              <span className="text-3xl">{item.icon}</span>
              <span className="text-sm font-medium text-gray-700">{item.label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}